import React from 'react';
import stye from './overlay-wrap-style.module.scss';

const Overlay = React.forwardRef((Props, ref) => {
   // console.log('>>> Overlay: ', Props);

   let visibilityClass = '';
   if (Props.visibility === 1) {
      visibilityClass = stye.show;
   } else {
      // visibilityClass = '';
   }

  return (
    <div ref={ref} className={`${stye.wrapper} ${visibilityClass}`}>
      {Props.children}
    </div>
  );
});

Overlay.displayName = 'Overlay';

export default Overlay;